export default (type) => {
    switch (type) {
        case 'success':
            return 'spark-icon-check'
        case 'warning':
            return 'spark-icon-alert-triangle'
        case 'error':
            return 'spark-icon-ban'
        default:
            return 'spark-icon-note'
    }
}


// WEBPACK FOOTER //
// ./src/shared/utils/messageIcon.js